var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.6667V8.66667C6 8.31304 5.85952 7.97391 5.60948 7.72386C5.35943 7.47381 5.02029 7.33333 4.66667 7.33333H3.33333C2.97971 7.33333 2.64057 7.47381 2.39052 7.72386C2.14048 7.97391 2 8.31304 2 8.66667V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H4.66667C5.02029 14 5.35943 13.8595 5.60948 13.6095C5.85952 13.3594 6 13.0203 6 12.6667ZM6 12.6667V6C6 5.64638 6.14048 5.30724 6.39052 5.05719C6.64057 4.80714 6.97971 4.66667 7.33333 4.66667H8.66667C9.02029 4.66667 9.35943 4.80714 9.60948 5.05719C9.85952 5.30724 10 5.64638 10 6V12.6667M6 12.6667C6 13.0203 6.14048 13.3594 6.39052 13.6095C6.64057 13.8595 6.97971 14 7.33333 14H8.66667C9.02029 14 9.35943 13.8595 9.60948 13.6095C9.85952 13.3594 10 13.0203 10 12.6667M10 12.6667V3.33333C10 2.97971 10.1405 2.64057 10.3905 2.39052C10.6406 2.14048 10.9797 2 11.3333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H11.3333C10.9797 14 10.6406 13.8595 10.3905 13.6095C10.1405 13.3594 10 13.0203 10 12.6667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarOutline);
export default __webpack_public_path__ + "static/media/ChartBarOutline.82829e060c7dc3ebf884ffc723002f52.svg";
export { ForwardRef as ReactComponent };